// extracted by mini-css-extract-plugin
export default {"root":"z2Fl0wCMKt5rrStRpkhc","value":"MKLeWHP0rb45cAk1weqU"};